import { render, staticRenderFns } from "./BButtonGroup.vue?vue&type=template&id=3932fc86&scoped=true&"
import script from "./BButtonGroup.vue?vue&type=script&lang=js&"
export * from "./BButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./BButtonGroup.vue?vue&type=style&index=0&id=3932fc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3932fc86",
  null
  
)

export default component.exports